<template>
    <el-card class="h-100">
        <page-header :title="title" :actions="actions" class="header"></page-header>
        <slot name="content"></slot>
    </el-card>
</template>

<script>
    import PageHeader from './PageHeader'

    export default {
        name: "Page",
        components: {
          PageHeader
        },
        props: {
            title: {
                required: true
            },
            actions: {
                default: []
            }
        }
    }
</script>

<style scoped>
    .header{
        margin-bottom : 1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page.vue